/* assets/variant-media-filter.js */
/* SAFE VERSION - prevents product images from disappearing */

(() => {
  const setVisible = (el, yes) => {
    if (!el) return;

    if (yes) {
      el.classList.remove("vmf-hidden");
      el.removeAttribute("hidden");
      el.style.display = "";
      el.style.visibility = "visible";
      el.style.opacity = "1";
      el.setAttribute("aria-hidden", "false");
    } else {
      el.classList.add("vmf-hidden");
      el.setAttribute("hidden", "hidden");
      el.style.display = "none";
      el.setAttribute("aria-hidden", "true");
    }
  };

  const apply = (sectionRoot) => {
    const gallery = sectionRoot.querySelector("media-gallery");
    if (!gallery) return;

    const slides = Array.from(
      gallery.querySelectorAll(".product__media-list > li.product__media-item")
    );

    const thumbs = Array.from(
      gallery.querySelectorAll(".thumbnail-list > li.thumbnail-list__item")
    );

    /* SHOW ALL IMAGES */
    slides.forEach((li) => {
      setVisible(li, true);
    });

    thumbs.forEach((li) => {
      setVisible(li, true);
    });

    /* Ensure first image is active */
    const firstVisibleSlide = slides[0];

    if (firstVisibleSlide) {
      slides.forEach((li) => li.classList.remove("is-active"));
      firstVisibleSlide.classList.add("is-active");

      firstVisibleSlide.style.display = "";
      firstVisibleSlide.removeAttribute("hidden");
      firstVisibleSlide.style.visibility = "visible";
      firstVisibleSlide.style.opacity = "1";
    }
  };

  const init = (sectionRoot) => {
    if (!sectionRoot) return;

    const run = () => apply(sectionRoot);

    setTimeout(run, 200);

    sectionRoot.addEventListener(
      "change",
      () => {
        setTimeout(run, 200);
      },
      true
    );

    window.addEventListener("load", () => {
      setTimeout(run, 300);
    });

    const gallery = sectionRoot.querySelector("media-gallery");

    if (gallery) {
      const mo = new MutationObserver(() => {
        setTimeout(run, 150);
      });

      mo.observe(gallery, {
        childList: true,
        subtree: true,
      });
    }
  };

  const boot = () => {
    document
      .querySelectorAll('[data-section-type="main-product"]')
      .forEach(init);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();